import React from 'react'
import { useStyles } from './TemplateDesignForm.styles'
import { TemplateCardProperties } from '../TemplateCardProperties/TemplateCardProperties'
import { TemplateSectionHeader } from '../TemplateSectionHeader/TemplateSectionHeader'
import { ButtonsTypesForm } from './FormComponents/ButtonsTypesForm/ButtonsTypesForm'
import { BadgesForm } from './FormComponents/BadgesForm/BadgesForm'
import { TemplateCardTextProperties } from '../TemplateCardTextProperties/TemplateCardTextProperties'
import { TemplateCardBodyTextProperties } from '../TemplateCardBodyTextProperties/TemplateCardBodyTextProperties'
import { TemplateCardStyling } from '../TemplateCardStyling/TemplateCardStyling'

import { LogoAvailability } from './FormComponents/LogoAvailabilityForm/LogoAvailabilityForm'
export const TemplateDesignForm: React.FC = () => {
  const { classes } = useStyles()

  return (
    <div className={classes.root}>
      {/* form creation here */}
      <TemplateCardProperties />
      <TemplateSectionHeader />
      <TemplateCardStyling />
      <TemplateCardTextProperties />
      <TemplateCardBodyTextProperties />
      <BadgesForm />
      <ButtonsTypesForm />
      <LogoAvailability />
    </div>
  )
}
